<div class="help-panel" *ngIf="topic">
  <div class="help-panel-header">
    <div class="help-panel-title">
      <mat-icon class="help-panel-icon">{{ topic.icon }}</mat-icon>
      <h2 mat-dialog-title>{{ topic.title }} help</h2>
    </div>
    <button mat-icon-button (click)="close()" aria-label="Close help">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="help-panel-content">
    <section class="help-block">
      <h3 class="help-block-title">What is it?</h3>
      <p class="help-block-text">{{ topic.whatIsIt }}</p>
    </section>

    <section class="help-block">
      <h3 class="help-block-title">What does it do?</h3>
      <ul class="help-block-list">
        <li *ngFor="let item of topic.whatDoesItDo">{{ item }}</li>
      </ul>
    </section>

    <section class="help-block">
      <h3 class="help-block-title">FAQ</h3>
      <mat-accordion displayMode="flat" [multi]="true" class="help-faqs">
        <mat-expansion-panel *ngFor="let faq of topic.faqs" class="help-faq">
          <mat-expansion-panel-header collapsedHeight="auto" expandedHeight="auto">
            <mat-panel-title class="help-faq-question">{{ faq.question }}</mat-panel-title>
          </mat-expansion-panel-header>
          <p class="help-faq-answer">{{ faq.answer }}</p>
        </mat-expansion-panel>
      </mat-accordion>
    </section>
  </mat-dialog-content>

  <mat-dialog-actions class="help-panel-actions">
    <button mat-button class="help-panel-all" (click)="viewAllHelp()">
      <mat-icon>menu_book</mat-icon>
      View all Help &amp; FAQs
    </button>
    <div class="help-panel-buttons">
      <app-contact-us-button></app-contact-us-button>
      <button mat-flat-button color="primary" (click)="close()">Close</button>
    </div>
  </mat-dialog-actions>
</div>
